import { render, staticRenderFns } from "./DriverSelectorItem.vue?vue&type=template&id=8b0e7968&scoped=true&lang=pug"
import script from "./DriverSelectorItem.vue?vue&type=script&lang=js"
export * from "./DriverSelectorItem.vue?vue&type=script&lang=js"
import style0 from "./DriverSelectorItem.vue?vue&type=style&index=0&id=8b0e7968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0e7968",
  null
  
)

export default component.exports